export const eWebinarButtonScript = `
  <script>
    (function(w, d, s, o, f, js, fjs) {
      w['eWidget'] = o;
      w[o] = w[o] || function() {
          (w[o].q = w[o].q || []).push(arguments)
      };
      if (d.getElementById(o)) return;
      js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      js.id = o;
      js.src = f;
      fjs.parentNode.insertBefore(js, fjs);
    }(window, document, 'script', '_ew', 'https://app.ewebinar.com/widget.js'));

    _ew('init', {
      "root": "w1761735293013",
      "isReview": false,
      "mode": "public",
      "openInPopup": false,
      "for": "Thankyou",
      "type": "ThankYou",
      "source": "",
      "url": "https://naturaily.com/webinar/why-you-should-migrate-from-magento-to-shopify",
      "shortUrl": "https://naturaily.ewebinar.com/webinar/15322",
      "sessions": [],
      "formType": "LatestForm",
      "ewebinar": {
        "title": "Migrating%20from%20Magento%20to%20Shopify",
        "borderRadius": 50,
        "primaryColor": "#ff4e30ff",
        "readableColor": "#ffffff",
        "actionColor": "#ff5e45ff",
        "readableActionColor": "#ffffff",
        "readableOnWhiteColor": "#ff4e30ff",
        "language": "en",
        "duration": 1862
      },
      "showGdprBanner": false,
      "gdprBannerMode": "Off",
      "gdprBannerText": "",
      "hideBranding": false,
      "teamId": "4439",
      "carouselId": "",
      "isWebinarRegPage": false,
      "isMobile": false,
      "initialized": false,
      "multiStepRegistration": false,
      "inSeriesLandingPage": false,
      "button": {
        "btnText": "Sign Up Now",
        "showButtonTimer": true,
        "buttonPrimaryColor": "#ff5e45ff",
        "buttonReadableColor": "#ffffff",
        "align": "Center",
        "isFullWidth": false,
        "step1BtnText": "Complete sign up →",
        "fontSize": "14"
      },
      "thankyou": {
        "onlyButton": true,
        "jitBtnText": "Go to session now",
        "addToCalendarBtnText": "Add to calendar",
        "replayBtnText": "Watch replay now"
      }
    });
    
    window.ewInit && window.ewInit();
  </script>
`;
